import { useState, useEffect } from 'react';
import PresentationContainer from 'react-presentation-container';
import { useQuery } from 'react-query';

import getIpData from '@/core/getIpData';

import Account from './Account.component';

export default PresentationContainer({
  component: Account,
  controller: function AccountController() {
    const {
      data: { data: { currency_code: currency = 'USD' } = {} } = {},
    } = useQuery('getIpData', () => getIpData());
    const [isMobileApp, setIsMobileApp] = useState(false);

    useEffect(() => {
      const v = window.sessionStorage.getItem('is_mobile_app');
      setIsMobileApp(Boolean(JSON.parse(v)));
    }, []);

    return { locale: { currency }, isMobileApp };
  },
});
